const MATCH_KIND_LABELS = {
  exact: 'Exact match',
  format_variant: 'Formatting variation',
  dob_name_variant: 'Similar name, same DOB',
  name_variant: 'Possible name variation',
};

export default MATCH_KIND_LABELS;
